import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { get, values } from 'lodash'

import Layout from '../../components/Layout'
import SuiteEdit from '../../containers/Suite/Edit'

import { getSelectedSuites } from '../../store/Suite/selector'

export const SuiteEditPage = ({ eventId, suiteNames, editPageType }) => {
  return (
    <Layout
      backTo={`/events/${eventId}`}
      iconType='close'
      isSidebar={true}
      subtitle={suiteNames}
      title={`Update ${editPageType}`}>
      <SuiteEdit />
    </Layout>
  )
}

const mapStateToProps = (state, ownProps) => {
  const eventId = get(ownProps, 'match.params.eventId')
  const editPageType = get(ownProps, 'match.params.customerOrAttendant') === 'customers' ? 'Customer' : 'Staff'
  const suiteNames = values(getSelectedSuites(state)).join(", ")
  return { eventId, suiteNames, editPageType }
}

export default withRouter(connect(mapStateToProps, null)(SuiteEditPage))
